import React, { useId } from 'react';

import { PHRFieldWrapper } from '@palmhr/palmhr-ui-lib';

import styles from './PolicyTextInput.module.scss';

// This feature needs label-derived accessible names; PHRTextInput overrides them with `name`.
const PolicyTextInput = ({ name, label, value, onChange, isRequired, type }) => {
  const id = useId();
  return (
    <PHRFieldWrapper name={name} className={`${styles.field} position-relative w-100`}>
      <div className={`${styles.label} d-flex justify-content-start`}>
        <label className='label' htmlFor={id}>
          {label}
          {isRequired && <sup aria-hidden='true'>*</sup>}
        </label>
      </div>
      <input
        className='form-control form-control- valid'
        type={type}
        name={name}
        id={id}
        value={value ?? ''}
        onChange={onChange}
        required={isRequired}
        autoComplete='off'
        spellCheck='false'
        maxLength='255'
      />
      <div className='invalid-feedback' />
    </PHRFieldWrapper>
  );
};

export default PolicyTextInput;
